function applyPAT(url: string): string {
    try {
        const burl = new URL(`https://${window.location.hostname}${url}`);

        const params = new URLSearchParams(window.location.search);

        if (params.has("pat")) {
            burl.searchParams.set("pat", params.get("pat")!);
        }

        return burl.toString();
    } catch (e) {
        console.error(e);
        return url;
    }
}

function applyLastClickedIndicator(el: HTMLElement, apply = true) {
    if (apply) {
        document.querySelectorAll('a.interactive-link-used').forEach(v => v.classList.remove('interactive-link-used'))
        if (el)
            el.classList.add("interactive-link-used");
    } else {
        el.classList.remove("interactive-link-used");
    }
}

export {applyPAT, applyLastClickedIndicator};
